// extracted by mini-css-extract-plugin
export default {"wrap":"lead-status-detail-module_wrap_NznZp","display":"lead-status-detail-module_display_Ez7Zr","hide":"lead-status-detail-module_hide_QhP6w"};